._2yvomg0 {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: start;
  flex-direction: column;
}
._2yvomg1 {
  margin-bottom: 0;
}
._2yvomg2 {
  margin-bottom: 16px;
}
@media screen and (min-width: 768px) {
  ._2yvomg0 {
    flex-direction: row;
  }
  ._2yvomg1 {
    margin-bottom: 4px;
  }
}